// src\stores\reducers\todos.ts
// import { LOADING } from '../../constants';
// import { ILoading } from '../types'



// const loadControll = (state: ILoading = {load: false, desc: ''}, action: { type: string; value: any }) => {
//   switch (action.type) {
//     case LOADING:
//       return  {
//         ...state,
//         ...action.value
//       };
//     default:
//       return state;
//   }
// };

// export default loadControll;
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING } from '../../constants';
import { ILoading } from '../types';

interface IState {
  loadControll: ILoading;
}

const initialState: ILoading = {
  load: false,
  desc: ''
};

const loadControllSlice = createSlice({
  name: 'loadControll',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<ILoading>) => {
      state.load = action.payload.load;
      state.desc = action.payload.desc;
    },
  },
});

export const { setLoading } = loadControllSlice.actions;

export default loadControllSlice;
